import React from "react"
import { Button, Card, Col, Row, Statistic, Table, Tooltip } from "antd"
import { ReloadOutlined } from "@ant-design/icons"
import { COLORS, TYPE_LABELS, formatDate, formatPoints } from "./format"

// Сегодня: что ушло в Tillypad и что ещё ждёт отправки кроном.
export function TodayCard({ today, isLoading, onRefresh }) {
  if (!today) return null

  const queue = today.queue ?? {}
  const columns = [
    { title: "Категория", dataIndex: "label" },
    { title: "Операция", dataIndex: "type", render: (type) => TYPE_LABELS[type] ?? type },
    { title: "Операций", dataIndex: "operations", align: "right" },
    { title: "Сумма", dataIndex: "points", align: "right", render: formatPoints },
  ]

  return (
    <Card
      size="small"
      style={{ marginBottom: 16 }}
      title={`Сегодня, ${today.date}: отправлено в Tillypad`}
      extra={
        <Tooltip title="Обновить">
          <Button size="small" icon={<ReloadOutlined />} loading={isLoading} onClick={onRefresh} />
        </Tooltip>
      }
    >
      <Row gutter={[24, 16]}>
        <Col xs={12} md={4}>
          <Statistic title="Начислено" value={today.accrued} suffix="₽" valueStyle={{ color: COLORS.accrued }} />
        </Col>
        <Col xs={12} md={4}>
          <Statistic title="Списано" value={today.written_off} suffix="₽" valueStyle={{ color: COLORS.writtenOff }} />
        </Col>
        <Col xs={12} md={4}>
          <Statistic title="Операций" value={today.operations} />
        </Col>
        <Col xs={12} md={4}>
          <Statistic title="Пользователей" value={today.users} />
        </Col>
        <Col xs={12} md={4}>
          <Statistic
            title="Ждут отправки"
            value={queue.operations ?? 0}
            valueStyle={{ color: queue.operations > 0 ? COLORS.burned : undefined }}
          />
        </Col>
        <Col xs={12} md={4}>
          <Statistic title="Старейшая в очереди" value={formatDate(queue.oldest_created_at)} valueStyle={{ fontSize: 16 }} />
        </Col>
      </Row>
      {today.by_category?.length > 0 && (
        <Table
          style={{ marginTop: 16 }}
          size="small"
          pagination={false}
          rowKey={(row) => `${row.category}-${row.type}`}
          dataSource={today.by_category}
          columns={columns}
        />
      )}
    </Card>
  )
}
